import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import landingPageInit from 'initializations/pages/CampaignLandingPrices'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
      landingPageInit.init("campaignLandingPrices")

      const LandingPage = () => import(/* webpackChunkName: "campaign-landing-page" */ 'containers/Pages/CampaignLandingPrices')
      new Vue({
        el: "#" + this.elemId,
        store,
        render: h => h(LandingPage)
      })
    }
}
